(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["driftroom-video-banner"] && !Shopify.designMode) return;
  try {
    
function initDriftroomVideo(){document.querySelectorAll('.dr-hero').forEach(hero=>{if(hero.dataset.ready)return;hero.dataset.ready='true';const video=hero.querySelector('video'),button=hero.querySelector('.dr-video-toggle');if(!video||!button)return;video.muted=true;const update=()=>{button.textContent=video.paused?'Play video':'Pause video';button.setAttribute('aria-label',button.textContent);};video.addEventListener('play',update);video.addEventListener('pause',update);button.addEventListener('click',()=>video.paused?video.play().catch(update):video.pause());const reduceMotion=window.matchMedia('(prefers-reduced-motion: reduce)').matches;if(reduceMotion){video.autoplay=false;video.pause();}else{video.autoplay=true;video.play().catch(update);video.addEventListener('loadeddata',()=>video.play().catch(update),{once:true});}update();});}initDriftroomVideo();document.addEventListener('shopify:section:load',initDriftroomVideo);

  } catch(e) { console.error(e); }
})();
})();
